// extracted by mini-css-extract-plugin
export default {"container":"loader_container__LHpUs","loader":"loader_loader__Hidtv","animloader":"loader_animloader__sYMnQ","animloader2":"loader_animloader2__iIBSz"};